import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Menu,
  Typography,
} from "@mui/material";
import MyBreakcrumbs from "../components/MyBreadcrumbs";
import MyTable from "../components/MyTable";
import React, { useState, useEffect } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { FaWhatsapp } from "react-icons/fa";
import SearchInput from "../components/SearchInput";
import { fetchPrescriptionsForClinic, fetchPrescriptionsForDoctor } from "../services/api";
import {serviceSendPrescriptionDataToWhatsapp} from "../../prescription/services/api"
import {
  getClinicIdFromToken,
  getToken,
  getValueFromToken,
} from "../utils/tokenUtils";
import { downloadFile, formatDateGlobal, getStartOrEndOfDay } from "../utils/commonUtils";
import { showToast } from "../utils/toastUtils";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import dayjs from "dayjs";
import AntDatePicker from "../components/antDatepicker";

function Prescriptions() {
  const columns = [
    { Header: "Id", accessor: "id" },
    { Header: "Patient Name", accessor: "patientName" },
    { Header: "Doctor Name", accessor: "doctorName" },
    { Header: "Appointment Date", accessor: "appointmentDate" },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <>
          <IconButton
            aria-label="view"
            onClick={() => window.open(row.original.url, "_blank")}
          >
            <VisibilityOutlinedIcon />
          </IconButton>
          <IconButton
            aria-label="download"
            color="primary"
            onClick={async () => {
              const url = row?.original?.url;
              const fileName = `Prescription-${row?.original?.id}`;
              await downloadFile(url, fileName);
            }}
          >
            <FileDownloadOutlinedIcon />
          </IconButton>
          <IconButton
            aria-label="print"
            color="info"
            onClick={() => {
              window.open(row.original.url, "_blank", "noopener,noreferrer");
            }}
          >
            <LocalPrintshopOutlinedIcon />
          </IconButton>
          <IconButton aria-label="whatsapp" color="success" modal="light" onClick={() => handleWhatsapp(row.original)}>
            <FaWhatsapp />
          </IconButton>
        </>
      ),
    },
  ];

  const [filterInput, setFilterInput] = useState("");
  const handleFilterChange = (event) => {
    const value = event.target.value || "";
    setFilterInput(value);
  };

  const [selectedTab, setSelectedTab] = useState("today");
  const [startDate, setStartDate] = useState(dayjs(getStartOrEndOfDay(new Date(), 'start')));
  const [endDate, setEndDate] = useState(dayjs(getStartOrEndOfDay(new Date(), 'end')));

  const breadcrumbs = [
    {
      label: "Home",
      href: "#",

      class: "text-[#2E37A4]",
    },
    { label: "Prescriptions", class: "text-[#2E37A4]" },
  ];

  // const prescriptions = [
  //   {
  //     id: 1,
  //     patientName: "John Doe",
  //     doctorName: "Dr. Smith",
  //     appointmentDate: "2024-02-12",
  //   },
  // ];

  const [prescriptions, setPrescriptions] = useState([]);

  const fetchData = async ({ clinic_id, doctor_id }) => {
    try {
      //const filters = { startDate, endDate };
      const filters = { startDate:getStartOrEndOfDay(startDate,'startdayjs'), endDate:getStartOrEndOfDay(endDate,'enddayjs') };
      const res = await fetchPrescriptionsForClinic({clinic_id, filters});
      if (res?.status) {
        const filteredPrescriptions = (res?.data || []).filter(prescription => prescription.url !== null);
        const formattedPrescriptions = filteredPrescriptions.map(prescription => ({
          ...prescription,
          id: prescription.id,
          patientId:prescription.patientId,
          patientName: prescription.patient_name,
          doctorName: prescription.doctor_name,
          appointmentDate: prescription.appointmentdate ? formatDateGlobal(prescription.appointmentdate) : "N/A",
          url: prescription.url,
        }));
        setPrescriptions(formattedPrescriptions);
      } else {
        console.error("Failed to fetch prescriptions");
      }
    } catch (error) {
      console.error("API call failed", error);
    }
  };
  const handleWhatsapp = async (data) => {
    const prescriptionData = {
      prescriptionId:data.id
    };
    const response = await serviceSendPrescriptionDataToWhatsapp(prescriptionData);
    if(response?.status){
      showToast(response.message, "success");
    }else{
      showToast(response.message, "error");
    }
  };

  const handleExport = () => {
    if(prescriptions.length === 0){
      showToast("No data to export", "error");
      return;
    }
    // Get headers (column names)
    const headers = Object.keys(prescriptions[0]);

    // Convert reports data to CSV format
    const csvData = prescriptions.map((report) => {
      return Object.values(report).join(",");
    });

    // Add headers to the start of the csvData array
    csvData.unshift(headers.join(","));

    // Create a blob containing the CSV data
    const blob = new Blob([csvData.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);
    
    downloadFile(url, "prescriptions.csv");
  };
  
  // Inside your component
  useEffect(() => {
    const clinic_id = getClinicIdFromToken(); // Hardcoding for now
    const doctor_id = getValueFromToken('doctor_id'); // Hardcoding for now
  
    fetchData({ clinic_id, doctor_id });
  }, [selectedTab, startDate, endDate]);

  return (
    <div className="page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 py-4 sm:py-6 md:px-8">
      <div className="pt-2 pb-6 flex justify-between items-center">
        <MyBreakcrumbs data={breadcrumbs} />
        <div className=" inline-flex items-center gap-x-3">
          <Button
            variant={selectedTab === "today" ? "contained" : "outlined"}
            onClick={() => {
              setSelectedTab("today");
              const today = new Date();
              setStartDate(getStartOrEndOfDay(today, 'start'));
              setEndDate(getStartOrEndOfDay(today, 'end'));
            }}
          >
            Today
          </Button>
          <Button
            variant={selectedTab === "yesterday" ? "contained" : "outlined"}
            onClick={() => {
              setSelectedTab("yesterday");
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              setStartDate(getStartOrEndOfDay(yesterday, 'start'));
              setEndDate(getStartOrEndOfDay(yesterday, 'end'));
            }}
          >
            Yesterday
          </Button>

          <Button
            variant={selectedTab === "custom" ? "contained" : "outlined"}
            onClick={() => {
              if (selectedTab !== "custom") {
                setSelectedTab("custom");
                const today = new Date();
                setStartDate(getStartOrEndOfDay(today, 'start')); // Set start date to today
                setEndDate(getStartOrEndOfDay(today, 'end')); // Set end date to today
              }
            }}
          >
            Custom
          </Button>
          {selectedTab === "custom" && (
            <>
              <div>
                <AntDatePicker
                  defaultValue={null}
                  placeholder="select date"
                  value={startDate? dayjs(startDate):startDate}
                  onChange={(date,dateString) => {
                    if (endDate && date > endDate) {
                      setEndDate(null);
                    }
                    setStartDate(dateString);
                  }}
                  disabledFutureDate={true}
                  maxDate={dayjs(endDate)}
                />
              </div>
              <div>
                <AntDatePicker
                  defaultValue={null}
                  placeholder="select date"
                  value={endDate? dayjs(endDate):endDate}
                  onChange={(date,dateStringE) => {
                    if (startDate && date < startDate) {
                      setStartDate(null);
                    }
                    setEndDate(dateStringE);
                  }}
                  minDate={dayjs(startDate)}
                />
              </div>
            </>
          )}
          <Button
            variant="contained"
            onClick={handleExport}
            style={{ backgroundColor: "#4caf50", color: "white" }}
            startIcon={<CloudDownloadIcon />}
          >
            Export Data
          </Button>
          <SearchInput
            filterInput={filterInput}
            handleFilterChange={handleFilterChange}
          />
        </div>
      </div>

      <div className="flex border-2 border-gray-300 shadow-lg rounded-lg bg-blue-50 mb-6">
        <div className=" flex-1 px-4  py-3">
          <span className="  font-normal"> Start Date: </span>
          <span className=" font-semibold">
            {formatDateGlobal(startDate)}
          </span>
        </div>
        <div className=" flex-1 px-4  py-3 ">
          <span className=" font-normal"> Last Date: </span>
          <span className=" font-semibold">
            {formatDateGlobal(endDate)}
          </span>
        </div>
        <div className=" flex-1 px-4  py-3 ">
          <span className=" font-normal"> Total Prescriptions: </span>
          <span className=" font-semibold"> {prescriptions?.length || 0} </span>
        </div>
      </div>

      <div className=" bg-white rounded-xl shadow-md shadow-gray-200 ">
        <div className=" px-5 py-3 flex flex-wrap md:flex-nowrap justify-between items-center gap-y-5">
          <div className=" text-lg  font-semibold  text-gray-800">
            Prescriptions
          </div>

          <div className=" inline-flex hidden">
            <form className=" relative w-[200px] xl:w-[270px]">
              <input
                type="text"
                className=" h-11  px-5 w-full pl-10 bg-transparent rounded-lg
  
                    text-gray-900 ring-0 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-0 outline-none focus:ring-inset focus:ring-indigo-600
                    "
                placeholder="Search here"
              />
              <a
                className=" absolute left-2.5 top-2.5"
                href="https://www.app.vitalx.in"
              >
                <img src="images/icons/search-normal.svg" alt="" />
              </a>
            </form>
          </div>
        </div>

        <div className=" overflow-auto px-4">
          <MyTable
            columns={columns}
            data={prescriptions}
            filterInput={filterInput}
            handleFilterChange={handleFilterChange}
            type="prescriptions"
          />
        </div>
        {/* Render the table */}
      </div>
    </div>
  );
}

export default Prescriptions;
